import { addHighlightToCache, addNoteToCache, removeHighlightFromCache, removeNoteFromCache } from './annotationsCache';

import type { CreateHighlight } from './CreateHighlight.mutation';
import type { CreateRoomNote } from './CreateRoomNote.mutation';
import type { DeleteHighlight } from './DeleteHighlight.mutation';
import type { DeleteRoomNote } from './DeleteRoomNote.mutation';
import type { Cache } from '@urql/exchange-graphcache';
import type { ResultOf, VariablesOf } from 'gql.tada';

export const annotationMutationUpdates = {
  createHighlight: (
    result: ResultOf<typeof CreateHighlight>,
    args: VariablesOf<typeof CreateHighlight>,
    cache: Cache,
  ) => {
    if (result.createHighlight && args.input.meeting_code) {
      addHighlightToCache(cache, args.input.meeting_code, result.createHighlight);
    }
  },

  deleteHighlight: (
    result: ResultOf<typeof DeleteHighlight>,
    args: VariablesOf<typeof DeleteHighlight>,
    cache: Cache,
  ) => {
    if (result.deleteHighlight != null && args.input._id) {
      removeHighlightFromCache(cache, args.input._id);
    }
  },

  createAskableVideoRoomNote: (
    result: ResultOf<typeof CreateRoomNote>,
    args: VariablesOf<typeof CreateRoomNote>,
    cache: Cache,
  ) => {
    const { code, _room_id: roomId } = args.input;
    if (result.createAskableVideoRoomNote && code && roomId) {
      addNoteToCache(cache, { code, roomId }, result.createAskableVideoRoomNote);
    }
  },

  deleteAskableVideoRoomNote: (
    result: ResultOf<typeof DeleteRoomNote>,
    args: VariablesOf<typeof DeleteRoomNote>,
    cache: Cache,
  ) => {
    if (result.deleteAskableVideoRoomNote && args.input.code && args.input.id) {
      removeNoteFromCache(cache, args.input.code, args.input.id);
    }
  },
};
